<div class="row-container">
  <div class="col-12">
    @if (item | hasTitleImage) {
      <!-- Space is reserved up front so the card does not jump once the image resolves. -->
      <div class="offers-card__image">
        <rs-web-picture
          [src]="item | contentTitleImage | async"
          className="offers-image"
        ></rs-web-picture>
      </div>
    }
  </div>
  <div class="col-10">
    <rs-web-label [text]="item.title" className="h4 text-primary"></rs-web-label>
  </div>
  <div class="col-10">
    <rs-web-label [text]="item.text" className="body text-secondary"></rs-web-label>
  </div>
</div>
